/**
 * Normalise a thrown value into an `Error` (Sentry wants one; so do we).
 * Non-`Error` throws take `fallbackMessage` when one is given, otherwise
 * their string form.
 */
export function toError(value: unknown, fallbackMessage?: string): Error {
  if (value instanceof Error) {
    return value;
  }
  return new Error(fallbackMessage ?? String(value));
}
